import redux from './redux'

export default{
	open: args => {
    redux.store.dispatch({
      'type': 'open',
      'args': args
    })
  }
}
